// extracted by mini-css-extract-plugin
export default {"sales":"Sales_sales__bb0J8"};